import { gql } from '@apollo/client'

import { EVENT_FRAGMENT } from '../fragments'

const EVENTS_QUERY = gql`
  query events($page: Int!, $pageSize: Int!, $filters: EventFiltersInput!) {
    events(page: $page, pageSize: $pageSize, filters: $filters) {
      results {
        ...EventFragment
      }
      total
    }
  }
  ${EVENT_FRAGMENT}
`

export default EVENTS_QUERY
